export const handleState = [
  { label: '在办', value: 10 },
  { label: '暂停', value: 20 },
  { label: '成功', value: 30 },
  { label: '失败', value: 40 }
];

export const handleStateAdd = [
  { label: '在办', value: 10 },
  { label: '暂停', value: 20 },
  { label: '成功', value: 30 },
  { label: '退办', value: 41 },
  { label: '转办', value: 42 }
];

export const handleYesNo = [
  { label: '是', value: 1 },
  { label: '否', value: 2 }
];

export const handleReceived = [
  { label: '已签收', value: 1 },
  { label: '未签收', value: 2 }
];

export const handleNotice = [
  { label: '已通知', value: 1 },
  { label: '未通知', value: 2 }
];

export const handleStatus = [
  { label: '下达', value: 30 },
  { label: '失败', value: 40 }
];

export const handleDorm = [
  { label: '有', value: 1 },
  { label: '无', value: 2 }
];

export const handleStatus2 = [
  { label: '在办', value: 0 },
  { label: '在办', value: '' },
  { label: '成功', value: 30 },
  { label: '失败', value: 40 }
];

export const handlePosted = [
  { label: '已邮寄', value: 1 },
  { label: '未邮寄', value: 2 }
];

export const handleCheckPost = [
  { label: '已通过', value: 30 },
  { label: '未通过', value: 40 }
];

export const cbApplyType = [
  { label: '内诺', value: 1 },
  { label: '选考', value: 2 },
  { label: '中国面试', value: 3 },
  { label: '中国笔试', value: 4 },
  { label: '赴日面试', value: 5 },
  { label: '赴日笔试', value: 6 },
  { label: '事前审查', value: 7 }
];

export const cbApplyType2 = [
  { label: '选考', value: 1 },
  { label: '中国面试', value: 2 },
  { label: '中国笔试', value: 3 },
  { label: '赴日面试', value: 4 },
  { label: '赴日笔试', value: 5 },
];

export const jobDuty = [
  { label: '教授', value: 1 },
  { label: '准教授', value: 2 },
  { label: '讲师', value: 3 },
  { label: '助教', value: 4 },
];

export const materialStatus = [
  { label: '已收齐', value: 1 },
  { label: '未收齐', value: 2 },
];

export const serviceStatus = [
  { label: '出愿准备中', value: 10 },
  { label: '出愿在留准备中', value: 15 },
  { label: '出愿完成', value: 20 },
  { label: '出愿失败', value: 25 },
  { label: '申请成功', value: 30 },
  { label: '申请失败', value: 40 },
  { label: '在留准备', value: 50 }
];

export const applyStatus = [
  { label: '在办', value: 10 },
  { label: '有意向', value: 11 },
  { label: '内诺', value: 12 },
  { label: '选考', value: 13 },
  { label: '暂停申请', value: 20 }
];
